export const railsServerUrls = {
	home: 'https://mangomap.com',
	helpCentre: 'https://help.mangomap.com',
	submitHelpRequest: 'https://help.mangomap.com/hc/en-us/requests/new',
	pricing: 'https://mangomap.com/pricing',
};
